import { generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { VoucherI18nEditContainer } from "@/components/features/marketing/voucher/edit/i18n/ui/existing";

import { useGetVoucherI18nEditPageParams } from "./_hooks/use-get-voucher-edit-page-params";

export const MarketingVoucherI18nEditPage = () => {
	const { hotelID, voucherID, langCode } = useGetVoucherI18nEditPageParams();

	const navigator = {
		default: generatePath(PATHS.HOTEL.MARKETING.VOUCHER.EDIT, { hotelID, voucherID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.MARKETING.VOUCHER.I18N, { hotelID, voucherID, langCode }),
	};

	return (
		<PageMeta
			title="宿泊券の編集"
			url={generatePath(PATHS.HOTEL.MARKETING.VOUCHER.I18N, { hotelID, voucherID, langCode })}
		>
			<VoucherI18nEditContainer
				hotelID={hotelID}
				voucherID={voucherID}
				navigator={navigator}
				activeLangCode={langCode}
			/>
		</PageMeta>
	);
};

MarketingVoucherI18nEditPage.displayName = "MarketingVoucherI18nEditPage";
